module.exports = __webpack_public_path__ + "img/icon_ig.f4f2acec.svg";